import { PlayerPodcastCategory } from '@/modules/player/components/podcast-category';
import { withMotion } from '../hoc/with-motion';


const AnimatedPage = withMotion(PlayerPodcastCategory);

export const roles: string[] = [];
export const path = '/player/all-podcasts/:category';
export const element = <AnimatedPage />